import {Classes} from "./Constants";
import {isValidIpAddress} from "./IpAddressValidation";
import {validateSingleEmailAddress} from "./EmailAddressValidation";

export class Expressions {
    static readonly DATE = /^(\d{4})-(0?[1-9]|1[012])-(0?[1-9]|[12]\d|3[01])$/u;
    static readonly BIG_DECIMAL = /^-?(?:\.\d{1,2}|\d{1,15}(?:\.\d{0,2})?)$/u;
    static readonly INTEGER = /^(?:-?[1-9]\d*|0)$/u;
    static readonly POSITIVE_NUMBER = /^\+?(?:\.\d+|\d+(?:\.\d*)?)$/u;
    static readonly HYPERLINK = /(?:^|[^"<>])\bhttps?:\/\/[^\s<>]+/giu;
    static readonly FILE_NAME = /^\.+$|["*/:<>?\\|]/u;

    static #applyHighlight(isValid: boolean, element?: HTMLElement, highlight?: boolean) {
        if (!isValid && element && highlight) {
            element.classList.add(Classes.ERROR);
        }
    }

    static validateRegExResult(pattern: RegExp, value: string, element?: HTMLElement, highlight?: boolean): RegExpExecArray {
        const match = pattern.exec(value);
        Expressions.#applyHighlight(Boolean(match), element, highlight);
        return match;
    }

    static validate(pattern: RegExp, value: string, element?: HTMLElement, highlight?: boolean): boolean {
        return !!Expressions.validateRegExResult(pattern, value, element, highlight);
    }

    static validateEmail(value: string, element?: HTMLElement, highlight?: boolean): boolean {
        const valid = validateSingleEmailAddress(value);
        Expressions.#applyHighlight(valid, element, highlight);
        return valid;
    }

    static validateIpAddressRange (value: string, element?: HTMLElement, highlight?: boolean): boolean {
        const valid = isValidIpAddress(value);
        Expressions.#applyHighlight(valid, element, highlight);
        return !!valid;
    }

    static validateIpAddressRanges (value: string, element?: HTMLElement, highlight?: boolean): boolean {
        // Don't allow blank/empty values for the range
        if (value === '' || (typeof value === 'string' && value.trim() === '')) {
            if (highlight) {
                element.classList.add(Classes.ERROR);
            }
            return false;
        }
        // To avoid using an even more complicated RegEx for ranges,
        // we will split the list of ranges first, and then trim and
        // validate each one separately. This helps to avoid DOS
        // vulnerabilities from the input strings.
        return String(value).split(',')
            // Trim all the values as there can be spaces in them
            .map(range => range.trim())
            // Validate each of the ranges by itself
            .map((range) => Expressions.validateIpAddressRange(range, element, highlight))
            // reduce the validation results for each one to a single
            // value that will be false if any entry is false
            .reduce((acc, cur) => cur && acc, true);
    }
}
